import { clsx } from 'clsx';
import { FC } from 'react';
import styles from './SelectOption.css';
import { Checkbox, TooltipDesktop, UIText2, UIText3 } from '@cian/ui-kit';
import { preventDefault } from 'shared/utils/event';
import { IconFunctionalInformation16, IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import { TSelectOptionValue } from 'shared/types/filters';

interface ISelectOptionProps {
  value: TSelectOptionValue;
  label: string;
  subtitle?: string;
  marker?: string;
  description?: string;
  index: number;
  multiple?: boolean;
  selected: boolean;
  withDivider?: boolean;
  onClick(e: React.MouseEvent<HTMLDivElement>): void;
}

export const SelectOption: FC<ISelectOptionProps> = ({
  multiple,
  selected,
  label,
  subtitle,
  marker,
  description,
  withDivider,
  onClick,
}) => {
  return (
    <div
      className={clsx(
        styles['option'],
        multiple && styles['multiple'],
        subtitle && styles['with-subtitle'],
        withDivider && styles['option-with-divider'],
      )}
      onClick={onClick}
    >
      {multiple && (
        <div className={styles['checkbox']}>
          <Checkbox checked={selected} onClick={preventDefault} />
        </div>
      )}

      {!multiple && selected && (
        <div className={styles['icon']}>
          <IconFunctionalSuccess16 color="icon-main-default" />
        </div>
      )}

      <div className={styles['content']}>
        <span className={styles['label']}>
          {label}
          {marker && (
            <span className={styles['marker']}>
              <UIText3 fontWeight="bold" color="text-inverted-default">
                {marker}
              </UIText3>
            </span>
          )}
        </span>
        {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
      </div>

      {description && (
        <span className={styles['info']} onClick={preventDefault}>
          <TooltipDesktop
            placement="top-end"
            title={
              <div className={styles['tooltip-content']}>
                <UIText2 color="white_100" textAlign="left">
                  {description}
                </UIText2>
              </div>
            }
          >
            <span className={styles['info-badge']}>
              <IconFunctionalInformation16 color="icon-main-default" />
            </span>
          </TooltipDesktop>
        </span>
      )}
    </div>
  );
};
